module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/mitsubishi-housenet-f940caa73db387446650bdc71bb54b07.png";